import maButtonsNextActions from '@/components/button-blue'
import maAccordion from '@/components/accordion'
import maModal from '@/components/modal'
import maNavbarStepper from '@/components/navbarStepper'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION,
  UPDATE_LOADER
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import { FLOW_MODULE_NAME } from '@/modules/Flow/store/types'
import { billmaChangeE2EFlow } from '@/modules/Claim/services/sinister'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damageFraisValidation',

  mixins: [flowMixin],

  components: {
    maButtonsNextActions,
    maAccordion,
    maModal,
    maNavbarStepper
  },
  data() {
    return {
      damages: {},
      fraisDamages: {}
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyHasUpptecDamage: 'hasUpptecDamage'
    }),

    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyResultDeclaration: 'resultDeclaration',
      stateWarrantySinisterSummary: 'sinisterSummary',
      stateWarrantyWarranties: 'warranties'
    }),
    ...mapState(FLOW_MODULE_NAME, {
      stateFlowState: 'flowState',
      stateFlowViewOptions: 'flowViewOptions'
    }),
    ...mapState(['date']),
    fraisCompensation() {
      return this.stateFlowViewOptions.smart_values.frais.compensation_base
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),

    ...mapMutations(['setNewDate']),

    updateStateWithDate() {
      this.$store.commit('setNewDate', this.date)
      return this.date
    },

    setDamagesData() {
      this.damages = JSON.parse(
        JSON.stringify(this.stateFlowViewOptions.smart_values)
      )
    },

    handleFraisData() {
      const damages = this.damages.frais

      let { compensation_base, ...fraisDamages } = damages

      this.fraisDamages = Object.values(fraisDamages)
    },

    handleOpenDescriptionModal() {
      this.$refs.modalDescription.showModal = true
    },
    handleCloseDescriptionModal() {
      this.$refs.modalDescription.showModal = false
    },

    handlePrimaryButtonClick() {
      if (
        this.damages.mobilier &&
        (this.getFlowState === 'COMPENSATION_MOBILIER' || this.getFlowState === 'GAG_DETAILS')
      ) {
        this.goToNextState(FLOW_TRANSITIONS.MOBILIER_FINISHED_OK, {
          date: this.updateStateWithDate()
        })
      } else {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_RESUME, {
          date: this.updateStateWithDate()
        })
      }
    },

    async handleSecondaryButtonClick() {
      try {
        if (this.isE2EFlow) {
          await billmaChangeE2EFlow(this.getSinisterId, 'frais')
        }
        if (
          this.damages.mobilier &&
          this.getFlowState === 'COMPENSATION_MOBILIER'
        ) {
          this.goToNextState(FLOW_TRANSITIONS.CALLBACK_REQUEST)
        } else {
          this.goToNextState(FLOW_TRANSITIONS.CALLBACK_REQUEST)
        }
      } catch (error) {
        const context = {
          component: 'damageFraisValidation',
          method: 'handleSecondaryButtonClick',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error changing E2E flow: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'handleSecondaryButtonClick'
        )

      }
    }
  },
  mounted() {
    this.setDamagesData()
    this.handleFraisData()
  }
}
